export default __webpack_public_path__ + "static/Continuous Integration 1-535c2ecacdd3d48f66f5b9389ba74a9c.png";